import { __extends } from "tslib";
import { Filter3DTaskBase } from '../Filter3DTaskBase';
var VERTEX_DEF = "\nprecision highp float;\nuniform float yflip;\nattribute vec4 aPosition;\nattribute vec4 aUv;\n\nvarying vec4 vUv;\n\nvoid main() {\n\tvUv = aUv;\n\tvec4 pos = aPosition;\n\tpos.z = pos.z * 2.0 - pos.w;\n\tgl_Position = pos;\n}\n";
var FRAG_DEF = "\nprecision highp float;\nuniform vec4 fc[2];\nuniform sampler2D uSampler0;\nvarying vec4 vUv;\n\nvoid main() {\n    vec4 color = texture2D(uSampler0, vUv.xy);\n    gl_FragColor = color;\n}\n\n";
var Filter3DTaskBaseWebGL = /** @class */ (function (_super) {
    __extends(Filter3DTaskBaseWebGL, _super);
    function Filter3DTaskBaseWebGL() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Filter3DTaskBaseWebGL.prototype.updateProgram = function (stage) {
        if (this._program3D)
            this._program3D.dispose();
        this._program3D = stage.context.createProgram();
        this._registerCache.reset();
        this._program3D.name = this.constructor.name;
        this._program3D.uploadRaw(this.getVertexCode(), this.getFragmentCode());
        this._program3DInvalid = false;
    };
    Filter3DTaskBaseWebGL.prototype.getVertexCode = function () {
        return VERTEX_DEF;
    };
    Filter3DTaskBaseWebGL.prototype.getFragmentCode = function () {
        return FRAG_DEF;
    };
    return Filter3DTaskBaseWebGL;
}(Filter3DTaskBase));
export { Filter3DTaskBaseWebGL };
